/* eslint-disable no-console */
import moment from 'moment';

import {ISelect} from '../../interface/ISelect';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import useUserStore from '../../store/userStore/userStore';
import {formatIndian} from '../../utils/formatIndian';
import {
  labelFromOtherStored,
  OTHER_VALUE_PREFIX
} from '../CustomInputs/Select/SelectWithOtherOption';
import {unitTypes} from '../Forms/interface/unitChange';
import changeUnit from '../Forms/Utils/changeUnit';

import {objTypes} from './Constants/commonConstants';

export const renderFormPreview: (
  value: any,
  obj: any,
  interRelatedKey: any
) => any = (value, obj, interRelatedKey) => {
  const facilityDetails = useCompanyStore.getState().facilityDetails;
  const {userDetails} = useUserStore.getState();

  if (
    (value === null || value === undefined) &&
    !obj?.isMaker &&
    obj?.type !== objTypes.userCreation
  ) {
    return obj.text ?? '-';
  } else {
    switch (obj.type) {
      case objTypes.string:
        return value || '-';
      case objTypes.phoneNumber:
        return formatPhonePreview(value);
      case objTypes.number: {
        const displayUnit = obj.unit === 'Miles' ? 'mi' : obj.unit;

        return obj.unit
          ? obj.isCost
            ? `${displayUnit} ${formatIndian(value)}`
            : `${formatIndian(value)} ${displayUnit}`
          : formatIndian(value);
      }
      case objTypes.percentage:
        return `${value} %` || '-';
      case objTypes.relatedUnit:
        return `${formatIndian(value)} ${changeUnit(
          obj.format?.find((item: any) => {
            return item?.value === interRelatedKey;
          })?.state ?? unitTypes.NA
        )}`;
      case objTypes.facilityFormPreview:
        return obj?.isMaker
          ? userDetails.facilityName
          : facilityDetails?.[interRelatedKey].find((items: any) => {
              return items._id === value;
            })?.name;
      case objTypes.productRelatedKey:
        return value === undefined
          ? null
          : `${formatIndian(value)} ${changeUnit(
              obj.format.find((item: any) => {
                return item?.value === interRelatedKey;
              })?.state ?? unitTypes.NA
            )}`;
      case objTypes.date:
        return moment(value).format(obj.format);
      case objTypes.boolean:
        return value === true ? 'Yes' : 'No';
      case objTypes.userCreation:
        if (typeof interRelatedKey === 'string') {
          return interRelatedKey.trim().length > 0 ? 'Yes' : 'No';
        }

        return interRelatedKey != null && interRelatedKey !== '' ? 'Yes' : 'No';

      case objTypes.valueInPair:
        return Array.isArray(value)
          ? value.map((item: any) => {
              const formatItem = obj.format.find(
                (formatItem: any) =>
                  formatItem.value === item?.[obj.renderFormat[0]]
              );
              const unit = obj.format.find(
                (formatItem: any) =>
                  formatItem.value === item?.[obj.renderFormat[0]]
              )?.state;
              if (obj.renderFormat.length === 1) {
                return formatItem ? `${formatItem.label}` : '';
              } else {
                return formatItem
                  ? `${formatItem.label} - ${formatIndian(
                      item?.[obj.renderFormat[1]]
                    )} ${changeUnit(unit)}`
                  : '';
              }
            })
          : '';
      case objTypes.arrayPair:
        return Array.isArray(obj.format)
          ? value.map((item: any) => {
              const formatItem1 = obj?.format[0].find(
                (formatItem: any) =>
                  formatItem.value === item?.[obj.renderFormat[0]]
              )?.label;
              const formatItem2 = Array.isArray(value)
                ? obj.format[1]
                    .filter((formatItem: any) => {
                      return item?.[obj.renderFormat[1]]?.includes(
                        formatItem.value
                      );
                    })
                    .map((item: any) => {
                      return ` ${item?.label}`;
                    })
                : '';

              return `${formatItem1} ${
                obj?.renderFormat.length > 1 ? `- ${formatItem2}` : ''
              }`;
            })
          : '';
      case objTypes.supplierData:
        return obj?.format
          .filter((item: any) =>
            value
              .map((item: any) => {
                return item?.supplierId;
              })
              .includes(item.value)
          )
          .map((item: any) => item.label);
      case objTypes.json:
        return Array.isArray(value)
          ? obj?.format
              .filter((item: ISelect) => {
                return value.includes(item.value);
              })
              .map((item: ISelect) => {
                return item?.label;
              })
          : obj?.format.find((item: ISelect) => {
              return item?.value === value;
            })?.label;
      case objTypes.json_has_other_option:
        return Array.isArray(value)
          ? obj?.format
              .filter((item: ISelect) => {
                return value.includes(item.value);
              })
              .map((item: ISelect) => {
                return item?.label;
              })
          : typeof value === 'string' && value.startsWith(OTHER_VALUE_PREFIX)
            ? labelFromOtherStored(value)
            : obj?.format.find((item: ISelect) => {
                return item?.value === value;
              })?.label;
      default:
        return value;
    }
  }
};

export const allCurrenciesArray = (): any => {
  const unitPreference = useJSONStore.getState().unitPreference;
  const currencyArray = Object.values(unitPreference).map((item: any) => {
    return item.currency;
  });

  return currencyArray;
};

export const renderTimeframeDataUnit = (value: any, unit: string): any => {
  const currencyArray = allCurrenciesArray();
  const isCost = currencyArray.includes(unit);
  const displayUnit = unit === 'Miles' ? 'mi' : unit;

  return `${isCost ? displayUnit : value} ${isCost ? value : displayUnit}`;
};

export const normalizeEmail = (value: string): string => {
  return value?.trim()?.toLowerCase();
};
export const normalizeMobile = (value: string): string => {
  return value?.trim()?.replace(/\D/g, '');
};

/** True when value is empty or only a dial/country code (≤3 digits). */
export const isEmptyPhoneNumber = (value: string): boolean => {
  const digitsOnly = value.toString().replace(/\D/g, '') ?? '';

  return !value || digitsOnly.length <= 3;
};

export const formatPhonePreview = (value: string): string => {
  return isEmptyPhoneNumber(value) ? '-' : String(value);
};
